module.exports = __webpack_public_path__ + "static/media/view9_front.f47f6e46.png";